
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.172 1.318l.582-.555c.512-.488 1.335-.494 1.84-.013l.584.557a1.201 1.201 0 01-.014 1.756l-.608.58M2.414 8.286l1.93 1.857","stroke":"#fff","stroke-width":".7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M2.897 10.986l-1.931.55.573-1.857 1.358 1.307z","stroke":"#fff","stroke-width":".7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M1.999 8.17l7.13-6.849 1.22 1.172 1.237 1.155-7.13 6.849-3.49 1.039L1.999 8.17z","stroke":"#fff","stroke-width":".7","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    